(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-layout-rotating-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-rotating-images').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            transitionDuration: 200,
            slideGap: '0px',
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ss-quantity-selector-v-1-0"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.inputElement = this.querySelector('input');
      this.#prepareEventHandlers();
    }

    #prepareEventHandlers() {
      const minusButton = this.querySelector('[name="minus"]');
      const plusButton = this.querySelector('[name="plus"]');

      [minusButton, plusButton].forEach((button) => {
        button.addEventListener('click', this.#onButtonClick);
      });
    }

    #onButtonClick = (event) => {
      event.preventDefault();
      const currentValue = parseInt(this.inputElement.value);
      const newValue = event.target.name === 'plus' ? currentValue + 1 : currentValue - 1;
      this.inputElement.value = newValue > 0 ? newValue : 1;
    };
  }

  if (!customElements.get('ss-quantity-input')) {
    customElements.define('ss-quantity-input', QuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ss-variant-picker-v-1-0"] && !Shopify.designMode) return;
  try {
    class ProductInputs extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.shopify-section');
      this.hiddenVariantInput = this.section.querySelector(`input[name="id"]`);
      this.inputElement = this.querySelector(`[name="id"]`);
      this.addEventListener('change', this.#updateHiddenInput);
    }

    #updateHiddenInput = () => {
      this.hiddenVariantInput.value = this.inputElement.value;
    };
  }

  if (!customElements.get('ss-product-inputs')) {
    customElements.define('ss-product-inputs', ProductInputs);
  }
  } catch(e) { console.error(e); }
})();

})();
